import React from 'react';
import _get from 'lodash/get';
import Heading from '../../Atoms/Heading/Heading';
import Button from '../../Atoms/Button/Button';
import { getStartOrderUrl } from '../../../Utils/componentUtils';
import './EmptyResponse.scss';

type EmptyResponseProps = {
    dictionary: any;
};

const EmptyResponse: React.FC<EmptyResponseProps> = ({ dictionary }) => {
  return (
    <div className="empty__list">
      <Heading
        className="empty__list--title"
        level="h1"
        title={dictionary && _get(dictionary, 'title', '')}
        testAutoId='recent-empty-title'
      />
      <p className="empty__list--description" data-testauto-id='recent-empty-desc'>{_get(dictionary, 'content', '')}</p>
      <Button
        testAutoId={'start-order'}
        onClick={() => {
          window.location.href = getStartOrderUrl();
        }}
        className="secondary__btn secondary__btn--upper secondary__btn--darkHover"
      >
        {_get(dictionary, 'ctaText', '')}
      </Button>
    </div>
  );
};

export default EmptyResponse;
